module.exports = __webpack_public_path__ + "assets/img/mecha-btn-4c591793.png";